import Route from '@ember/routing/route';

export default class EntriesAllRoute extends Route
{
	async model()
	{
		const event = this.modelFor("event");
		// Pre-load event-level data so it's in the store when entries render
		// startTimingRecords - needed for every entry row
		// intermediateTimingPoints - shared definitions, needed when viewing entry details
		await Promise.all([
			event.get('startTimingRecords'),
			event.get('intermediateTimingPoints')
		]);
		return event;
	}
}
